import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzTableQueryParams, NzTableSortOrder } from 'ng-zorro-antd/table';
import { DataserviceService } from '../dataservice.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { CustomerProfileComponent } from './customer-profile/customer-profile.component';
import { AppComponent } from '../app.component';
import { FormControl, FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent implements OnInit {
  currentUser: any;
  filteredCustomers: any = [];
  providersList: any;
  pageSize = 10;
  pageIndex = 1;
  total = 0;
  private searchDebouncer = new Subject<void>();
  isLoading = false;
  sortName: string | null = 'sale_date';
  sortValue: NzTableSortOrder | null = 'descend';
  visible: boolean = false;
  filterForm: FormGroup;
  status: any = [];
  statusObj: any;
  columnNames = [
    { value: 'first_name', label: 'Name', visible: true, sortable: true },
    { value: 'phone_number', label: 'Phone', visible: false, sortable: true },
    { value: 'address', label: 'Address', visible: true, sortable: true },
    { value: 'rep', label: 'Rep', visible: true, sortable: true },
    { value: 'fiber_provider_id', label: 'Provider', visible: true, sortable: true },
    { value: 'convert_date', label: 'Sale Date', visible: true, sortable: true },
    { value: 'install_date', label: 'Install Date', visible: true, sortable: true },
    { value: 'provider_status', label: 'Status', visible: true, sortable: true },
    { value: 'update_date', label: 'Last Updated', visible: false, sortable: true },
    { value: 'notesArray', label: 'Notes', visible: false, sortable: false }
  ];
  hideProviders: boolean = false;

  constructor(
    private dataService: DataserviceService,
    private modal: NzModalService,
    private app: AppComponent,
    private message: NzMessageService
  ) {

    this.searchDebouncer
      .pipe(debounceTime(300))
      .subscribe(() => this.getAllCustomers());

    this.filterForm = new FormGroup({
      'name': new FormControl(''),
      'rep': new FormControl(''),
      'phone_number': new FormControl(''),
      'address': new FormControl(''),
      'order_id': new FormControl(''),
      'change_date': new FormControl(''),
      'provider': new FormControl(''),
      'status': new FormControl(''),
      'sale_date': new FormControl(''),
      'install_date': new FormControl(''),
    })
  } 

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    this.getProviders();

    const savedColumns = localStorage.getItem('columnNames');

    if (savedColumns && savedColumns != 'undefined') {
      this.columnNames = JSON.parse(savedColumns);
    }else {
      localStorage.setItem('columnNames', JSON.stringify(this.columnNames));
    }

  }

  onVisibleColumnsChange() {
    localStorage.setItem('columnNames', JSON.stringify(this.columnNames));
  }

  setParams() {
    let params = new HttpParams()
      .set('page', this.pageIndex.toString())
      .set('pageSize', this.pageSize.toString())
      .set('rep', this.filterForm.get('rep')?.value)
      .set('number',this.filterForm.get('order_id')?.value)
      .set('phone_number', this.filterForm.get('phone_number')?.value.replace(/\D/g, ''))
      .set('address', this.filterForm.get('address')?.value)
      .set('sortField', this.sortName || '')
      .set('sortOrder', this.sortValue || '')
      .set('name', this.filterForm.get('name')?.value)
      .set('change_date',this.filterForm.get('change_date')?.value)
      .set('install_date',this.filterForm.get('install_date')?.value)
      .set('sale_date',this.filterForm.get('sale_date')?.value)
      .set('status', this.filterForm.get('status')?.value ? this.statusObj[this.filterForm.get('status')?.value] : '')
      .set('provider',this.filterForm.get('provider')?.value)

    if(this.app.hasPermission('see_all_dish_accounts') && !this.currentUser.super_admin) {
      this.hideProviders = true;
      const dish = this.providersList.find((p: any) => p?.name?.toLowerCase() == 'dish')
      this.filterForm.get('provider')?.setValue(dish.name);
      params = params.set('provider',this.filterForm.get('provider')?.value)
    }
  
    if (this.hasPermissions('view_all_customers')) {
      params = params.set('all', true);
    } else if (this.hasPermissions('view_distributor_customers')) {
      params = params.set('distributor_id', this.currentUser.distributor_id);
    } else if (this.hasPermissions('view_company_customers')) {
      params = params.set('company_id', this.currentUser.company_id);
    } else if (this.currentUser?.viewable_groups?.length > 0) {
      if(!this.currentUser?.viewable_groups.includes(this.currentUser?.id)) {
        this.currentUser?.viewable_groups.push(this.currentUser.id)
      }
      params = params.set('viewable_groups', this.currentUser.viewable_groups);
    } else {
      params = params.set('my_id', this.currentUser.id);
    }

    // console.log(params)

    return params;
  }

  getAllDishCustomers() {
    this.isLoading = true;

    this.dataService.getData('work-order/allDishWos')
      .subscribe({
        next: (res: any) => {   
          const customers = Array.isArray(res?.data) ? res?.data : [];
          this.filteredCustomers = customers.map((c: any) => ({
            ...c,
            notesArray: this.parseNotes(c.notes)
          }));
          this.total = customers.length;
          this.isLoading = false;
        },
        error: (err: any) => {
          console.error(err)
          this.message.error('Failed to getcustomers')
          this.isLoading = false;
        }
      })
  }

  getAllCustomers() {
    this.isLoading = true;
    let params = this.setParams();

    this.dataService.getData('work-order/all', { params })
      .subscribe({
        next: (res: any) => {   
          const statusData = res?.status || {};
          this.statusObj = statusData;
          this.status = Object.keys(statusData);

          const customers = Array.isArray(res?.data) ? res?.data : [];
          this.filteredCustomers = customers.map((c: any) => ({
            ...c,
            notesArray: this.parseNotes(c.notes)
          }));
          this.total = res?.total ?? customers.length;
          this.isLoading = false;
        },
        error: (err: any) => {
          console.error(err)
          this.message.error('Failed to getcustomers')
          this.isLoading = false;
        }
      })
  }

  getProviders(){
    this.isLoading = true;
    this.dataService.getData('providers').subscribe((r: any)=>{
      this.providersList = r.data;
      this.getAllCustomers();
    })
  }

  parseNotes(notes: string | any[]): any[] {
    try {
      return typeof notes === 'string' ? JSON.parse(notes) : notes || [];
    } catch {
      return [];
    }
  }

  downloadList() {
    this.isLoading = true;
    let params = this.setParams();
    this.dataService.getData('work-order/download', { params })
      .subscribe({
        next: (res: any) => {
          this.generateCsv(res.data)
          this.isLoading = false;
        },
        error: (err: any) => {
          console.error(err)
          this.message.error('Failed to getcustomers')
          this.isLoading = false;
        }
      })
  }

  generateCsv(data: any) {
    const csv = this.convertToCSV(data);
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    
    const a = document.createElement('a');
    a.href = url;
    a.download = 'knockvia-customers.csv';
    a.click();
  }

  convertToCSV(data: any) {
    const header = Object.keys(data[0]).join(',') + '\n';
    const rows = data.map((row: any) => Object.values(row).join(',')).join('\n');
    return header + rows;
  }

  hasPermissions(permission: string): boolean {
    return this.app.hasPermission(permission)
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    if(this.pageIndex != params.pageIndex) {
      this.getAllCustomers();
    }
    this.pageIndex = params.pageIndex;
    this.pageSize = params.pageSize;
  }

  search(bool: any): void {
    if(bool) {
      this.visible = false;
    }
    this.searchDebouncer.next();
  }

  sort(value: NzTableSortOrder, key: string): void {
    this.isLoading = true;
    this.sortName = key;
    this.sortValue = value;
    this.search(false);
  }

  showCustomerDetails(customer: any): void {
    this.isLoading = true;
    if(!customer.id){
      this.message.error('ID is not found')
      this.isLoading = false;
      return
    }
    this.dataService.getData('work-order/by-id/' + customer?.id)
      .subscribe({
        next: (r: any) => {
          const modal = this.modal.create({
            nzContent: CustomerProfileComponent,
            nzFooter: null,
            nzMaskClosable: false,
            nzClosable: false,
            nzData: {
              customer: r?.customer,
              wos: r?.wos,
              duplicate: r?.dup,
              permission: this.hasPermissions('manage_customer')
            },
          });

          modal.afterClose.subscribe((data: any) => {
            if (data) {
              this.getAllCustomers();
            }
          });
          this.isLoading = false;
        },
        error: (err: any) => {
          this.isLoading = false;
          console.error(err)
          this.message.error('Failed to get customer details')
        }
      })
  }

  openDrawer() {
    this.visible = true;
  }

  close() {
    this.visible = false;
  }

  resetFilterForm() {
    this.filterForm.patchValue({
      'name': '',
      'rep': '',
      'phone_number': '',
      'address': '',
      'order_id': '',
      'change_date': '',
      'sale_date': '',
      'install_date': '',
      'status': '',
      'provider': ''
    });
    this.search(false);
  }

  nonEmptyFilterCount(): number {
    if (!this.filterForm) return 0;
    const values = Object.values(this.filterForm.value);
    return values.filter(v => v !== '').length;
  }

  getStatusColor(status: string) {
    if (!status) {
       return 'default';
    }
    const s = status.toLowerCase();

    if (s == 'active' || s == 'completed')  {
      return 'green';
    }
    if (s.includes('inactive') || s.includes('cancel')) {
      return 'red';
    } 
    if (s === 'default') {
      return 'default';
    } 
    return 'yellow';
  }

  resetColumns() {
    this.columnNames = [
      { value: 'first_name', label: 'Name', visible: true, sortable: true },
      { value: 'phone_number', label: 'Phone', visible: false, sortable: true },
      { value: 'address', label: 'Address', visible: true, sortable: true },
      { value: 'rep', label: 'Rep', visible: true, sortable: true },
      { value: 'fiber_provider_id', label: 'Provider', visible: true, sortable: true },
      { value: 'install_date', label: 'Install Date', visible: true, sortable: true },
      { value: 'convert_date', label: 'Sale Date', visible: true, sortable: true },
      { value: 'provider_status', label: 'Status', visible: true, sortable: true },
      { value: 'update_date', label: 'Last Updated', visible: false, sortable: true },
      { value: 'notesArray', label: 'Notes', visible: false, sortable: false }
    ];
    localStorage.setItem('columnNames', JSON.stringify(this.columnNames));
  }
} 
